import { Drawer, Tabs, TabsProps } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import productStore from '../../../stores/productStore';
import InformationProduct from '../ProductComponents/InformationProduct';

export const statusOptions = [
    {
        value: 'PENDING',
        label: 'Pendente'
    },
    {
        value: 'ACCEPTED',
        label: 'Aprovado'
    },
    {
        value: 'REJECTED',
        label: 'Reprovado'
    }
];

interface ModalProductsProps {
    isModalOpen: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    product: any;
    isModel?: boolean;
}

const ModalProducts: React.FC<ModalProductsProps> = observer(({ isModalOpen, isModel, setIsModalOpen, product }) => {
    useEffect(() => {
        return () => {
            productStore.reset();
        };
    }, [product]);

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Informação do Produto',
            children: <InformationProduct isModel={isModel} productUuid={product?.uuid} />,
        },
    ];


    return (
        <Drawer
            title="Informações do Produto"
            width={800}
            onClose={() => setIsModalOpen(false)}
            open={isModalOpen}
        >

            <Tabs defaultActiveKey="1" items={items} />
        </Drawer>
    );
});

export default ModalProducts;
